import { useGalleryStore } from "../../stores/Gallery.store";

export const useGalleryImages = () => {
  const showGallery = useGalleryStore(state => state.showGallery);

  const show = (imagesUrls: string[]) => {
  const images = imagesUrls.map((url, index) => ({
      id: index,
      url: url,
    }));

    showGallery(images);
  };

  return {
    show
  };
};
